import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class EmploymentService extends BaseService {
	constructor() {
		super('/Employment');
	}

	public getAllByFilter(filter: EmploymentFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class EmploymentFilter extends BaseFilter {
	constructor(
		idEmployment?: number | null,
		idWorkingGroup?: number | null,
		idTenant?: number | null,
		idOperationRecord?: number | null,
		isConditions?: boolean | null,
		isSubstitute?: boolean | null,
		list?: string | null,
		isSubstituteList: boolean | null = false,
		isDeleted: boolean | null = false
	) {
		super();
		this._idEmployment = idEmployment;
		this._idWorkingGroup = idWorkingGroup;
		this._idTenant = idTenant;
		this._idOperationRecord = idOperationRecord;	
		this._isConditions = isConditions;
		this._isSubstitute = isSubstitute;
		this._isSubstituteList = isSubstituteList;
		this._list = list;
		this._isDeleted = isDeleted
	}

	private _idEmployment?: number | null;
	private _idWorkingGroup?: number | null;
	private _idTenant?: number | null;

	private _idOperationRecord?: number | null;
	private _isConditions?: boolean | null;
	private _isSubstitute?: boolean | null;
	private _isSubstituteList?: boolean | null;
	private _list?: string | null;
	private _isDeleted?: boolean | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idEmployment != null ? { IdEmployment: this._idEmployment } : {}),
			(this._idWorkingGroup != null ? { IdWorkingGroup: this._idWorkingGroup } : {}),
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._idOperationRecord != null ? { IdOperationRecord: this._idOperationRecord } : {}),			
			(this._isConditions != null ? { IsConditions: this._isConditions } : {}),
			(this._isSubstitute != null ? { IsSubstitute: this._isSubstitute } : {}),
			(this._isSubstituteList != null ? { IsSubstituteList: this._isSubstituteList } : {}),
			(this._isDeleted != null ? { IsDeleted: this._isDeleted } : {}),
			(this._list != null ? { List: this._list } : {})
		);
	
		return data;
	};
}